import React, { useState, useMemo } from 'react';
import './Sidebar.css';
import iconLogo from '../assets/icon.png';
import { isWeb } from '../utils/platform';

function Sidebar({ activeMenu, onMenuSelect }) {
  const [scriptsOpen, setScriptsOpen] = useState(false);

  const allNavItems = [
    { label: 'Home', icon: '🏠', description: 'Main dashboard' },
    { label: 'Scripts', icon: '📝', hasSubmenu: true, description: 'Content creation tools' },
    { label: 'Fiddy AI Chat', icon: '🧠', description: 'Chat with AI assistant' },
    { label: 'Work Plan', icon: '📋', description: 'Task and project management' },
    { label: 'Content Editor', icon: '✏️', description: 'Advanced script editing' },
    { label: 'Browser', icon: '🌐', description: 'Secure web browsing', desktopOnly: true },
    { label: 'Text to Speech', icon: '🔊', description: 'Voice generation' },
    { label: 'Humanizer', icon: '🤖', description: 'AI content humanization with optimal balance' },
    { label: 'FB Search Trend', icon: '📊', description: 'Discover Facebook search trends and insights', desktopOnly: true },
    { label: 'YT Search Trend', icon: '▶️', description: 'YouTube search suggestions and creator insights', desktopOnly: true },
    { label: 'Image Generation', icon: '🖼️', description: 'Bulk image generation via API or automation', desktopOnly: true },
    { label: 'Grok Auto-Pilot', icon: '🎨', description: 'Queue Grok Imagine / video generations', desktopOnly: true },
    { label: 'Tutorials', icon: '📚', description: 'Learning resources' },
    { label: 'License Info', icon: '🔐', description: 'License information and status' },
    { label: 'Settings', icon: '⚙️', description: 'App configuration' },
    { label: 'Help', icon: '❓', description: 'Support & guidance' }
  ];

  const navItems = useMemo(
    () => (isWeb ? allNavItems.filter((item) => !item.desktopOnly) : allNavItems),
    []
  );

  const scriptSubmenu = [
    { label: 'Advertisements', icon: '📢' },
    { label: 'Articles & Blogs', icon: '📄' },
    { label: 'Customer Service', icon: '🎧' },
    { label: 'Ebooks', icon: '📖' },
    { label: 'Ecommerce', icon: '🛒' },
    { label: 'Emails', icon: '📧' },
    { label: 'Letters', icon: '✉️' },
    { label: 'Marketing', icon: '📈' },
    { label: 'Other', icon: '🔧' },
    { label: 'Podcasts', icon: '🎙️' },
    { label: 'Press Releases', icon: '📰' },
    { label: 'Research', icon: '🔍' },
    { label: 'Reviews', icon: '⭐' },
    { label: 'Rewriter', icon: '🔄' },
    { label: 'SEO', icon: '🎯' },
    { label: 'Social Media', icon: '📱' },
    { label: 'Video Scripts', icon: '🎬' },
    { label: 'Website Copy', icon: '🌐' }
  ];



  const handleMenuClick = (item) => {
    if (item.label === 'Scripts') {
      setScriptsOpen(!scriptsOpen);
    } else {
      onMenuSelect(item.label);
      setScriptsOpen(false);
    }
  };

  const handleSubmenuClick = (subItem) => {
    onMenuSelect(subItem.label);
    setScriptsOpen(false);
  };

  const handleClose = () => {
    if (window.electronAPI && window.electronAPI.closeApp) {
      window.electronAPI.closeApp();
    } else {
      window.close();
    }
  };

  return (
    <div className="sidebar">
      {/* Header with Brand */}
      <div className="sidebar-header">
        <div className="brand">
          <div className="brand-logo">
            <img 
              src={iconLogo} 
              alt="Fiddyscript Logo" 
              width="40" 
              height="40"
              style={{ filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))' }}
            />
          </div>
          <div className="brand-text">
            <h1 className="brand-title">Fiddyscript</h1>
            <p className="brand-subtitle">AI Content Assistant</p>
          </div>
        </div>
      </div>
      
      {/* Navigation Menu */}
      <nav className="sidebar-nav">
        {navItems.map((item, index) => (
          <div key={index} className="nav-item-container">
            <button
              className={`nav-item ${activeMenu === item.label ? 'active' : ''}`}
              onClick={() => handleMenuClick(item)}
              title={item.description}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
              {item.hasSubmenu && (
                <span className={`nav-arrow ${scriptsOpen ? 'open' : ''}`}>▼</span>
              )}
            </button>
            
            {item.hasSubmenu && scriptsOpen && item.label === 'Scripts' && (
              <div className="submenu">
                {scriptSubmenu.map((subItem, subIndex) => (
                  <button
                    key={subIndex}
                    className={`submenu-item ${activeMenu === subItem.label ? 'active' : ''}`}
                    onClick={() => handleSubmenuClick(subItem)}
                  >
                    <span className="submenu-icon">{subItem.icon}</span>
                    <span className="submenu-label">{subItem.label}</span>
                  </button>
                ))}
              </div>
            )}

          </div>
        ))}
      </nav>

      {/* Footer */}
      <div className="sidebar-footer">
        <button className="close-btn" onClick={handleClose}>
          <span className="close-icon">✕</span>
          <span className="close-text">Close App</span>
        </button>
      </div>
    </div>
  );
}

export default Sidebar;